<template>
  <div class="fruitList container">
    <div class="banner">
      <img src="http://img.wish.hebyun.com.cn/images/fruit_bg.png" />
    </div>
    <!-- 内容区 -->
    <van-pull-refresh v-model="isDownLoading" @refresh="onRefresh">
      <div class="main">
        <van-list
          v-model="vantList_IsLoading"
          :finished="vantList_IsLoadOver"
          offset="20"
          :finished-text="'我是有底线的'"
          :finish-text="'数据加载完毕'"
          :loading-text="'数据加载中...'"
          @load="onUpRefreshLoad"
        >
          <Fruit :fruitList="fruitList" />
        </van-list>
      </div>
      <van-empty
        class="custom-image"
        description="暂无心愿"
        v-if="data_lengthShow == false"
        image="http://img.wish.hebyun.com.cn/images/empty_state.png"
      />
    </van-pull-refresh>
    <!-- 发布圆梦故事 -->
    <Button :button="button" v-if="isShowButton" @click.native="jumpRelease" />
    <div class="side_bars" v-if="isLogin()">
      <img
        src="http://img.wish.hebyun.com.cn/images/share_icon.png"
        @click="share"
      />
      <img
        src="http://img.wish.hebyun.com.cn/images/return_con.png"
        v-if="isFirstPage"
        @click="goback"
      />
    </div>
  </div>
</template>

<script>
import Fruit from "@/components/Fruit";
import Button from "@/components/Button";
export default {
  components: { Button, Fruit },
  name: "fruitList",
  data() {
    return {
      button: "发布圆梦故事",
      page: 1,
      limit: 10,
      isEmpty: false,
      fruitList: [],
      loading: false,
      textUpFinish: "没有更多了",
      isDownLoading: false, // 下拉刷新
      vantList_IsLoading: false,
      vantList_IsLoadOver: false,
      data_lengthShow: true,
      isShowButton: false,
      isFirstPage: false,
    };
  },
  created() {
    this.queryData();

    if (this.isLogin()) {
      this.queryUserInfo();
    }

    let isFirstPage = localStorage.getItem("isFirstPage");
    if (isFirstPage == "0") {
      this.isFirstPage = true;
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    share() {
      var url = window.location.href;

      var msg = {
        shareTitle: "我为群众办实事 党员帮办微心愿",
        shareSummary: "提交心愿、认领心愿、互动点赞，请登录“冀云”客户端",
        shareUrl: url,
        shareImage: "http://img.wish.hebyun.com.cn/images/wyxShare.jpg",
      };
      const u = navigator.userAgent,
        app = navigator.appVersion;
      console.log(app);
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.webkit.messageHandlers.nativeShare.postMessage(
          JSON.stringify(msg)
        );
      } else {
        window.jsInterface.nativeShare(JSON.stringify(msg));
      }
    },
    // 查询
    async queryData() {
      this.vantList_IsLoading = true;
      let params = {
        page: this.page,
        limit: this.limit,
      };
      let { data } = await this.$api.queryFruitList(params);
      if (data) {
        data.forEach((item) => {
          item.is_thumb = 0;
        });
      }
      if (this.page == 1) {
        this.fruitList = data;
      } else {
        this.fruitList = this.fruitList.concat(data);
      }
      this.vantList_IsLoading = false;
      if (data.length < this.limit) {
        this.vantList_IsLoadOver = true;
      } else {
        this.vantList_IsLoadOver = false;
        this.page = this.page + 1;
      }
    },
    beforeRouteEnter(to, from, next) {
      if (from.fullPath.indexOf("fruitDetail") !== -1) {
        //判断是从哪个路由过来的，若是detail页面不需要刷新获取新数据，直接用之前缓存的数据即可
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if (!this.$route.meta.isBack || this.isFirstEnter) {
        // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
        // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
        this.fruitList = [];
        // 把数据清空，可以稍微避免让用户看到之前缓存的数据

        this.queryData();
        this.queryUserInfo();
      }
      // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
      this.$route.meta.isBack = false;
      // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
      this.isFirstEnter = false;
    },
    // 下拉加载
    onRefresh() {
      this.page = 1;
      this.queryData();
      this.$toast("刷新成功");
      this.isDownLoading = false;
    },

    // 上划分页
    onUpRefreshLoad() {
      this.queryData();
    },
    // 发布圆梦故事
    jumpRelease() {
      this.$router.push("/releaseStory");
    },
    // 是否展示发布圆梦故事按钮
    async queryUserInfo() {
      let { data } = await this.$api.queryUserInfo();
      if (data.type === 3) {
        this.isShowButton = true;
      } else {
        this.isShowButton = false;
      }
    },
  },
};
</script>
<style>
.fruitList > .btn {
  position: fixed;
  left: 50%;
  width: 210px;
  height: 36px;
  bottom: 30px;
  margin-left: -105px;
}
.fruitList > .btn span {
  font-size: 14px;
}
</style>
<style scoped lang="scss">
.fruitList {
  min-height: 100vh;
  box-sizing: border-box;
  height: auto;
  /deep/.van-pull-refresh {
    margin-top: -14px;
  }
  .banner {
    position: relative;
    width: 375px;
    img {
      width: 100%;
    }
  }
  /* 内容区 */
  .main {
    width: 100%;
    height: auto;
    min-height: calc(100vh - 130.5px);
    box-sizing: border-box;
    // background-color: #f9f1c7;
    margin-top: 0;
    margin-bottom: 40px;
    /deep/.van-empty {
      height: calc(100vh - 130.5px);
    }
  }
}
</style>
